$(window).on('load', function () {
    var two = new Two({
            type: Two.Types.svg,
            fullscreen: false,
            height: $(window).height(),
            width: $(window).width(),
            autostart: true
        }).appendTo($('#lineStage').get(0)),
        shape,
        intervalai = [],
        enterHandler = function (e, child) {
            var pageX = e.pageX;
            //console.log(child);
            if (child.basePoints.going == 0) {
                child.basePoints.going = 1;
                intervalai[child.id] = setInterval(function (elem, id) {
                    var whereTo = elem.basePoints.where * elem.basePoints.offset;

                    var x = elem.translation.x;
                    var y = elem.basePoints.y + whereTo;

                    elem.basePoints.offset -= 0.05;
                    elem.basePoints.where = elem.basePoints.where * (-1);

                    if (elem.basePoints.offset <= 0) {
                        elem.translation.set(elem.basePoints.x, elem.basePoints.y);
                        elem.basePoints.offset = 3;
                        elem.basePoints.where = 1;
                        elem.basePoints.going = 0;
                        clearInterval(intervalai[id]);
                    } else {
                        elem.translation.set(x, y);
                    }
                }, 30, child, child.id);
            }


            // setTimeout(function(){
            //     $('#lineStage').removeClass('going');
            // }, 500);

        };

    var svg = $('#backstage svg').get(0);
    shape = two.interpret(svg).center();
    shape.xMoving = 1;
    shape.yMoving = 1;


    shape.fill = '#5e97ff';
    shape.visible = true;
    shape.stroke = 'rgba(0,0,0,0)';
    shape.linewidth = 15;
    //shape.noStroke();
    shape.scale = 1.4 * (window.innerWidth / 1440);
    shape.translation.set(two.width / 2, two.height / 2);
    two.update();

    _.each(shape.children, function (child, i) {
        child.basePoints = {
            x: child.translation.x,
            y: child.translation.y,
            offset: 3,
            where: 1,
            going: 0
        };

        $(child._renderer.elem).on('mouseenter', function (e) {
            // if (!$('#lineStage').hasClass('going')) {
            var audio = $('audio.'+$(this).attr('id')).get(0);
            audio.currentTime = 0;
            setTimeout(function () {
                audio.play();
            }, 200)
            enterHandler(e, child);
            //     $('#lineStage').addClass('going');
            // }
        });
    });

    $(window).on('resize', function () {
        shape.translation.set(two.width / 2, two.height / 2);
        if (window.innerWidth > 599) {
            shape.scale = 1.4 * (window.innerWidth / 1440);
        } else {
            shape.scale = 1.4 * (599 / 1440);
        }
    });

    two.bind('update', function (frameCount) {
        var xMax = (two.width / 2) + (two.width / 8),
            xMin = (two.width / 2) - (two.width / 8),
            yMax = (two.height / 2) + (two.height / 16),
            yMin = (two.height / 2) - (two.height / 16),
            shapePos = shape.translation,
            newX, newY;

        if (shapePos.x >= xMax) {
            shape.xMoving = -1;
        }
        if (shapePos.x <= xMin) {
            shape.xMoving = 1;
        }
        if (shapePos.y >= yMax) {
            shape.yMoving = -1;
        }
        if (shapePos.y <= yMin) {
            shape.yMoving = 1;
        }

        newX = shapePos.x + (0.2 * shape.xMoving);
        newY = shapePos.y + (0.1 * shape.yMoving);

        shape.translation.set(newX, newY);
    }).play();
});
